export const EXTERNALTAB_COMPOSE = "externaltab_compose";
export const EXPANDED_COMPOSE = "expanded_compose";
export const MINIMIZE_COMPOSE = "minimized_compose";
export const MAXIMIZE_COMPOSE = "maximized_compose";
export const COLLAPSE_COMPOSE = "collapse_compose";
export const HIDE_COMPOSE = "hide_compose";

export const DRAFT_IDLE = "draft_idle";
export const DRAFT_SAVING = "draft_saving";
export const DRAFT_FAILED = "draft_failed";
export const DRAFT_SAVED = "draft_saved";

export const MAX_COMPOSE = 3;
export const COMPOSE_WIDTH = 600;
export const COMPOSE_GAP = 10;
